import { observer } from "mobx-react";
import './index.css';
import strings from '../../localization';
import { Link, useLocation } from "react-router";
import Profile from "../Profile";
import { selfixSmallLogoIcon } from "../../assets";
import { DomPurifyHtml } from "../DomPurifyHtml";

const DashboardSideBarItem = ({ item, selectedItem, index }) => {

  if (item.path === selectedItem) {
    return (
      <div
        className={`dashboard-side-bar-item ${selectedItem === item.path ? 'dashboard-side-bar-item-selected' : ''}`}
        key={index}>
        <DomPurifyHtml
          className={'dashboard-side-bar-item-icon-colored'}
          html={item.coloredIcon}
        />

        <DomPurifyHtml
          className={'dashboard-side-bar-item-icon-uncolored'}
          html={item.icon}
        />
        <span>{item.label}</span>
      </div>
    );
  }
  return (
    <Link to={item.path}
      className={`dashboard-side-bar-item ${selectedItem === item.path ? 'dashboard-side-bar-item-selected' : ''}`}
      key={index}>
      <DomPurifyHtml
        className={'dashboard-side-bar-item-icon-colored'}
        html={item.coloredIcon}
      />

      <DomPurifyHtml
        className={'dashboard-side-bar-item-icon-uncolored'}
        html={item.icon}
      />
      <span>{item.label}</span>
    </Link>
  );
};

const DashboardSideBar = () => {

  const router = useLocation();


  const items = [
    {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="46" height="45" viewBox="0 0 46 45" fill="transparent">
              <path d="M30.875 35.1H38.75V31.95C38.75 29.3405 36.6345 27.225 34.025 27.225C32.5199 27.225 31.1792 27.9287 30.3139 29.0251M30.875 35.1H15.125M30.875 35.1V31.95C30.875 30.9164 30.6759 29.9294 30.3139 29.0251M15.125 35.1H7.25V31.95C7.25 29.3405 9.36545 27.225 11.975 27.225C13.4801 27.225 14.8208 27.9287 15.6861 29.0251M15.125 35.1V31.95C15.125 30.9164 15.3241 29.9294 15.6861 29.0251M15.6861 29.0251C16.8473 26.1241 19.6843 24.075 23 24.075C26.3157 24.075 29.1527 26.1241 30.3139 29.0251M27.725 14.625C27.725 17.2346 25.6095 19.35 23 19.35C20.3905 19.35 18.275 17.2346 18.275 14.625C18.275 12.0155 20.3905 9.90002 23 9.90002C25.6095 9.90002 27.725 12.0155 27.725 14.625ZM37.175 19.35C37.175 21.0897 35.7647 22.5 34.025 22.5C32.2853 22.5 30.875 21.0897 30.875 19.35C30.875 17.6103 32.2853 16.2 34.025 16.2C35.7647 16.2 37.175 17.6103 37.175 19.35ZM15.125 19.35C15.125 21.0897 13.7147 22.5 11.975 22.5C10.2353 22.5 8.825 21.0897 8.825 19.35C8.825 17.6103 10.2353 16.2 11.975 16.2C13.7147 16.2 15.125 17.6103 15.125 19.35Z" stroke="#464646" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`,
      coloredIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="46" height="45" viewBox="0 0 46 45" fill="none">
                      <path d="M30.875 35.0999H38.75V31.9499C38.75 29.3404 36.6345 27.2249 34.025 27.2249C32.5199 27.2249 31.1792 27.9286 30.3139 29.025M30.875 35.0999H15.125M30.875 35.0999V31.9499C30.875 30.9163 30.6759 29.9293 30.3139 29.025M15.125 35.0999H7.25V31.9499C7.25 29.3404 9.36545 27.2249 11.975 27.2249C13.4801 27.2249 14.8208 27.9286 15.6861 29.025M15.125 35.0999V31.9499C15.125 30.9163 15.3241 29.9293 15.6861 29.025M15.6861 29.025C16.8473 26.124 19.6843 24.0749 23 24.0749C26.3157 24.0749 29.1527 26.124 30.3139 29.025M27.725 14.6249C27.725 17.2344 25.6095 19.3499 23 19.3499C20.3905 19.3499 18.275 17.2344 18.275 14.6249C18.275 12.0154 20.3905 9.8999 23 9.8999C25.6095 9.8999 27.725 12.0154 27.725 14.6249ZM37.175 19.3499C37.175 21.0896 35.7647 22.4999 34.025 22.4999C32.2853 22.4999 30.875 21.0896 30.875 19.3499C30.875 17.6102 32.2853 16.1999 34.025 16.1999C35.7647 16.1999 37.175 17.6102 37.175 19.3499ZM15.125 19.3499C15.125 21.0896 13.7147 22.4999 11.975 22.4999C10.2353 22.4999 8.825 21.0896 8.825 19.3499C8.825 17.6102 10.2353 16.1999 11.975 16.1999C13.7147 16.1999 15.125 17.6102 15.125 19.3499Z" stroke="#7A63FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`,
      label: strings.dashboard,
      path: '/tech/dashboard',
    }
  ];


  const selectedItem = router.pathname;

  return (
    <div className="dashboard-side-bar" >
      <div className="dashboard-side-bar-items">
        {items.map((item, index) => (
          <DashboardSideBarItem item={item} key={index} selectedItem={selectedItem} index={index} />
        ))}
      </div>

      <div className="dashboard-side-bar-bottom">
        <Profile />
        <img src={selfixSmallLogoIcon} alt="selfix-small-logo" />
      </div>
    </div>
  );
};

export default observer(DashboardSideBar);